module.exports = __webpack_public_path__ + "img/AD.8bc447c3.jpg";